import { EntityDetailPage, EntityDetailView } from "../../common/entity/EntityDetailPage";
import { EntityDetailViewProps } from "../../common/entity/EntityInterfaces";
import { EntityTablePage } from "../../common/entity/EntityTablePage";
import { CustomFieldTemplateRenderer } from "./CustomFieldTemplateRenderer";
import { CustomFieldTemplatesTable } from "./Table/CustomFieldTemplatesTable";

export const CustomFieldTemplatesTablePage = () => {
  return (
    <EntityTablePage entityTypeId={"customFieldTemplates"}>
      {(props) => <CustomFieldTemplatesTable {...props} />}
    </EntityTablePage>
  );
};

export const CustomFieldTemplatesDetailsPage = () => {
  return (
    <EntityDetailPage<"customFieldTemplates"> isIntId>
      {(id) => <CustomFieldTemplatesDetailView id={id} />}
    </EntityDetailPage>
  );
};

export const CustomFieldTemplatesDetailView = ({ id }: EntityDetailViewProps<"customFieldTemplates">) => {
  return (
    <EntityDetailView id={id} entityTypeId={"customFieldTemplates"}>
      {(props) => <CustomFieldTemplateRenderer {...props} />}
    </EntityDetailView>
  );
};
